import { getHttpVtoken } from './HttpClient'
import decode from 'jwt-decode';
import { isEmpty } from 'lodash';

export const mapUserInfo = (loadUserInfo, keycloakToken, idToken, refreshToken) => {
    const name = loadUserInfo.name.split(" ")
    const firstName = name[0]
    const lastName = name[1]
    return {
        firstName,
        lastName,
        email: loadUserInfo.email,
        id: loadUserInfo.sub,
        token: keycloakToken,
        idToken,
        refreshToken,
    }
}

export const destroyUserInfo = () => {
    deleteCookie('contextInfo')
}

export const checkKeycloakToken = (keycloak) => {
    return new Promise((resolve, reject) => {
        keycloak
            .updateToken(window._env_.updateKeycloakToken)
            .then(async function (refreshed) {
                resolve(keycloak);
            }).catch(function (err) {
                console.error(err)
                reject(err)
            });
    });

}

export const genVRoomToken = async function (keycloak) {
    try {
        // console.log("old", keycloak.idToken.substr(keycloak.idToken.length - 4, keycloak.idToken.length));
        await checkKeycloakToken(keycloak);
        // console.log("new", keycloak.idToken.substr(keycloak.idToken.length - 4, keycloak.idToken.length));
        // console.log("new-keycloak", keycloak.idToken);
        const url = window._env_.subscriberServiceBaseURL + "/v1/token"
        const headers = {
            Authorization: "Bearer " + keycloak.idToken
        }
        const token = localStorage.getItem("vtoken")
        let vroomToken = {
            token
        }
        let data
        if (!isEmpty(vroomToken.token))
            data = decode(vroomToken.token)
        if (data?.exp * 1000 < Date.now() || isEmpty(vroomToken.token)) {
            vroomToken = await getHttpVtoken(keycloak, url, headers)
        }
        if (!isEmpty(vroomToken.token)) {
            localStorage.setItem("vtoken", vroomToken.token)
            setContextInfo(vroomToken.token)
            return vroomToken.token
        }
        return null
    } catch (error) {
        console.error('Generate token Error', error)
    }
}

export const getContextInfo = async (keycloak) => {
    let contextInfo = getCookie('contextInfo') ? JSON.parse(getCookie('contextInfo')) : {}
    if (isEmpty(contextInfo)) {
        const vroomToken = await genVRoomToken(keycloak)
        if (!isEmpty(vroomToken)) {
            const contextInfo = decode(vroomToken)
            const { user } = contextInfo.context
            const { avatar, p, pkgcode, name, email } = user
            return {
                avatar, p, pkgcode, name, email
            }
        }
    }
    return contextInfo
}

export const setContextInfo = (vroomToken) => {
    const contextInfo = decode(vroomToken)
    const { user } = contextInfo.context
    const { avatar, p, pkgcode, name, email } = user
    setCookie("contextInfo", JSON.stringify({ avatar, p, pkgcode, name, email }));
}

export const isExpire = (token) => {
    if (token && decode(token)) {
        const expiry = decode(token).exp;
        const now = new Date();
        return now.getTime() > expiry * 1000;
    }
    return true;
}


export const login = (keycloak, language) => {
    const lang = language === 'cn' ? 'zh-cn' : language
    if (!isEmpty(keycloak)) {
        // alert(this.state.keycloak.createLoginUrl())
        window.location.href = keycloak.createLoginUrl() + `&ui_locales=${lang}&clear=true`
        // console.log(this.state.keycloak)
    } else {
        // alert("keycloak is null");
        window.location.href = 'https://vroom-auth.truevirtualworld.com/auth/realms/vroom/protocol/openid-connect/logout';
    }
}

export const gotoregister = (keycloak, language) => {
    const lang = language === "cn" ? 'zh-cn' : language
    if (!isEmpty(keycloak)) {
        window.location.href = keycloak.createRegisterUrl() + `&ui_locales=${lang}&clear=true`
    }
}

export const refererRegister = (keycloak, language, referrer) => {
    //const lang = language === "cn" ? "zh-cn" : language
    if (!isEmpty(keycloak)) {
        //window.location.href = keycloak.createRegisterUrl({ redirectUri: `${window._env_.vRoomUrl}/portal` }) + `&ui_locales=${lang}&clear=true&referrer=${referrer}`
        window.location.href = `${window._env_.referrer}${window._env_.vRoomUrl}/&kc_locale=th&referrer=${referrer}`
    }
}

export const logoutByUser = (keycloak) => {
    if (!isEmpty(keycloak)) {
        keycloak.logout()
    }
    destroyUserInfo()
    localStorage.removeItem("vtoken")
}

export const setCookie = (name, value, time = { period: '', duration: 0 }) => {
    const hostName = window.location.host.split(':')
    let myDate = new Date();
    switch (time.period) {
        case 'minutes':
            myDate.setMinutes(myDate.getMinutes() + time.duration);
            break;
        case 'hours':
            myDate.setHours(myDate.getHours() + time.duration);
            break
        case 'months':
            myDate.setMonth(myDate.getMonth() + time.duration);
            break
        case 'years':
            myDate.setFullYear(myDate.getFullYear() + time.duration);
            break;
        default:
            myDate.setMonth(myDate.getMonth() + 12);
            break;
    }
    document.cookie = name + "=" + value + ";expires=" + myDate.toUTCString()
        + ";domain=" + hostName[0] + ";path=/"
}

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export const deleteCookie = (name) => {
    const hostName = window.location.host.split(':')
    document.cookie = name + "=;domain=" + hostName[0]
        + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
